import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_8 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_11 = {
  key: 0,
  class: "col-lg-6 col-md-6 mb-4"
}
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 1,
  class: "col-lg-6 col-md-6 mb-4"
}
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "my-4"
}
const _hoisted_16 = {
  key: 1,
  class: "row"
}
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "col-lg-6 mb-4" }
const _hoisted_19 = { class: "col-lg-6 mb-4" }
const _hoisted_20 = { class: "col-lg-6 mb-4" }
const _hoisted_21 = { class: "form-check form-switch mb-2" }
const _hoisted_22 = { class: "form-check form-switch" }
const _hoisted_23 = {
  key: 2,
  class: "row"
}
const _hoisted_24 = { class: "col-lg-6 mb-4" }
const _hoisted_25 = { class: "col-lg-6 mb-4" }
const _hoisted_26 = { class: "col-lg-6 mb-4" }
const _hoisted_27 = { class: "col-lg-6 mb-4" }
const _hoisted_28 = {
  key: 3,
  class: "row"
}
const _hoisted_29 = { class: "col-lg-6 mb-4" }
const _hoisted_30 = { class: "col-lg-6 mb-4" }
const _hoisted_31 = { class: "col-lg-6 mb-4" }
const _hoisted_32 = { class: "col-lg-6 mb-4" }
const _hoisted_33 = {
  key: 4,
  class: "row"
}
const _hoisted_34 = { class: "col-lg-6 mb-4" }
const _hoisted_35 = { class: "col-lg-6 mb-4" }
const _hoisted_36 = { class: "col-lg-6 mb-4" }
const _hoisted_37 = { class: "col-lg-6 mb-4" }
const _hoisted_38 = {
  key: 5,
  class: "row"
}
const _hoisted_39 = { class: "col-lg-6 mb-4" }
const _hoisted_40 = { class: "col-lg-6 mb-4" }
const _hoisted_41 = { class: "col-lg-6 mb-4" }
const _hoisted_42 = { class: "form-check form-switch mb-2" }
const _hoisted_43 = { class: "form-check form-switch" }
const _hoisted_44 = { class: "col-lg-6 mb-4" }
const _hoisted_45 = { class: "col-lg-6 mb-4" }
const _hoisted_46 = { class: "col-lg-6 mb-4" }
const _hoisted_47 = { class: "col-lg-6 mb-4" }
const _hoisted_48 = { class: "col-lg-6 mb-4" }
const _hoisted_49 = { class: "col-lg-6 mb-4" }
const _hoisted_50 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: 'Create Order',
      subTitle: "Transactions"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[34] || (_cache[34] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[36] || (_cache[36] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Customer", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.customer_id) = $event)),
                required: ""
              }, [
                _cache[35] || (_cache[35] = _createElementVNode("option", { value: "" }, "Select Customer", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (c) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: c.customer_id,
                    value: c.customer_id
                  }, _toDisplayString(c.name || c.phone_number), 9, _hoisted_6))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.form.customer_id]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[37] || (_cache[37] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Total Price (Rp)", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.total_price) = $event)),
                placeholder: "0",
                min: "0",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.total_price]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[39] || (_cache[39] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Klasifikasi Dokumen & Standar Acuan", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.similarity_profile_id) = $event)),
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onProfileSelect && _ctx.onProfileSelect(...args)))
              }, [
                _cache[38] || (_cache[38] = _createElementVNode("option", { value: null }, "-- Default (Artikel Jurnal) --", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.similarityProfiles, (p) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: p.id,
                    value: p.id
                  }, _toDisplayString(p.service_classification) + " — " + _toDisplayString(p.profile_name) + " (Maks. " + _toDisplayString(p.default_max_overall) + "%) ", 9, _hoisted_9))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.form.similarity_profile_id]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[41] || (_cache[41] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Service Type", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.service_type) = $event)),
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onServiceTypeChange && _ctx.onServiceTypeChange(...args))),
                required: ""
              }, _cache[40] || (_cache[40] = [
                _createStaticVNode("<option value=\"\">Select Service Type</option><option value=\"PLAGIARISM\">Plagiarism Check (Turnitin)</option><option value=\"PLAGIARISM_AI_CHECK\">Plagiarism &amp; AI Check (Drillbit)</option><option value=\"AI_CHECK\">AI Check (SciSpace)</option><option value=\"PARAPHRASE\">Paraphrase</option><option value=\"DOC_FIX\">Document Fix</option><option value=\"JOURNAL\">Journal Publication</option><option value=\"TRANSLATE\">Translation</option><option value=\"ALL\">All Services (Combination)</option><option value=\"PACKAGE\">Package/Bundle</option>", 10)
              ]), 544), [
                [_vModelSelect, _ctx.form.service_type]
              ])
            ]),
            (_ctx.form.service_type && _ctx.form.service_type !== 'PACKAGE')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[43] || (_cache[43] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Service", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.service_id) = $event)),
                    required: ""
                  }, [
                    _cache[42] || (_cache[42] = _createElementVNode("option", { value: "" }, "Select Service", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (s) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: s.service_id,
                        value: s.service_id
                      }, _toDisplayString(s.service_name), 9, _hoisted_12))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.form.service_id]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.service_type === 'PACKAGE')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _cache[45] || (_cache[45] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Package", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.package_id) = $event)),
                    required: ""
                  }, [
                    _cache[44] || (_cache[44] = _createElementVNode("option", { value: "" }, "Select Package", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packages, (p) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: p.package_id,
                        value: p.package_id
                      }, _toDisplayString(p.package_name), 9, _hoisted_14))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.form.package_id]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.form.service_type)
            ? (_openBlock(), _createElementBlock("hr", _hoisted_15))
            : _createCommentVNode("", true),
          (_ctx.form.service_type === 'PLAGIARISM' || _ctx.form.service_type === 'PLAGIARISM_AI_CHECK' || _ctx.form.service_type === 'AI_CHECK')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("h5", _hoisted_17, _toDisplayString(_ctx.form.service_type === 'PLAGIARISM_AI_CHECK' ? 'Plagiarism & AI Details' : (_ctx.form.service_type === 'AI_CHECK' ? 'AI Check Details' : 'Plagiarism Details')), 1),
                _createElementVNode("div", _hoisted_18, [
                  _cache[46] || (_cache[46] = _createElementVNode("label", { class: "form-label" }, "Source File Path/URL", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.details.plagiarism.source_file) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.details.plagiarism.source_file]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[48] || (_cache[48] = _createElementVNode("label", { class: "form-label" }, "Language", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.details.plagiarism.language) = $event))
                  }, _cache[47] || (_cache[47] = [
                    _createElementVNode("option", { value: "id" }, "Indonesian", -1),
                    _createElementVNode("option", { value: "en" }, "English", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.details.plagiarism.language]
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "exQ",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.details.plagiarism.exclude_quotes) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.details.plagiarism.exclude_quotes]
                    ]),
                    _cache[49] || (_cache[49] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "exQ"
                    }, "Exclude Quotes", -1))
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "exB",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.details.plagiarism.exclude_bibliography) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.details.plagiarism.exclude_bibliography]
                    ]),
                    _cache[50] || (_cache[50] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "exB"
                    }, "Exclude Bibliography", -1))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.form.service_type === 'PARAPHRASE')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _cache[57] || (_cache[57] = _createElementVNode("h5", { class: "mb-3" }, "Paraphrase Details", -1)),
                _createElementVNode("div", _hoisted_24, [
                  _cache[51] || (_cache[51] = _createElementVNode("label", { class: "form-label" }, "Source File Path/URL", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.details.paraphrase.source_file) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.details.paraphrase.source_file]
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _cache[53] || (_cache[53] = _createElementVNode("label", { class: "form-label" }, "Paraphrase Level", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.details.paraphrase.paraphrase_level) = $event))
                  }, _cache[52] || (_cache[52] = [
                    _createElementVNode("option", { value: "Light" }, "Light", -1),
                    _createElementVNode("option", { value: "Medium" }, "Medium", -1),
                    _createElementVNode("option", { value: "Heavy" }, "Heavy", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.details.paraphrase.paraphrase_level]
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[55] || (_cache[55] = _createElementVNode("label", { class: "form-label" }, "Language", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.details.paraphrase.language) = $event))
                  }, _cache[54] || (_cache[54] = [
                    _createElementVNode("option", { value: "id" }, "Indonesian", -1),
                    _createElementVNode("option", { value: "en" }, "English", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.details.paraphrase.language]
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _cache[56] || (_cache[56] = _createElementVNode("label", { class: "form-label" }, "Special Instructions", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.details.paraphrase.special_instructions) = $event)),
                    rows: "2"
                  }, null, 512), [
                    [_vModelText, _ctx.details.paraphrase.special_instructions]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.form.service_type === 'DOC_FIX')
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _cache[63] || (_cache[63] = _createElementVNode("h5", { class: "mb-3" }, "Document Fix Details", -1)),
                _createElementVNode("div", _hoisted_29, [
                  _cache[58] || (_cache[58] = _createElementVNode("label", { class: "form-label" }, "Raw File Path/URL", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.details.doc_fix.raw_file) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.details.doc_fix.raw_file]
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _cache[59] || (_cache[59] = _createElementVNode("label", { class: "form-label" }, "Guideline File Path/URL", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.details.doc_fix.guideline_file) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.details.doc_fix.guideline_file]
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _cache[61] || (_cache[61] = _createElementVNode("label", { class: "form-label" }, "Language", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.details.doc_fix.language) = $event))
                  }, _cache[60] || (_cache[60] = [
                    _createElementVNode("option", { value: "id" }, "Indonesian", -1),
                    _createElementVNode("option", { value: "en" }, "English", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.details.doc_fix.language]
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _cache[62] || (_cache[62] = _createElementVNode("label", { class: "form-label" }, "Fix Notes", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.details.doc_fix.fix_notes) = $event)),
                    rows: "2"
                  }, null, 512), [
                    [_vModelText, _ctx.details.doc_fix.fix_notes]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.form.service_type === 'JOURNAL')
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _cache[69] || (_cache[69] = _createElementVNode("h5", { class: "mb-3" }, "Journal Details", -1)),
                _createElementVNode("div", _hoisted_34, [
                  _cache[64] || (_cache[64] = _createElementVNode("label", { class: "form-label" }, "Manuscript File Path/URL", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.details.journal.manuscript_file) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.details.journal.manuscript_file]
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _cache[65] || (_cache[65] = _createElementVNode("label", { class: "form-label" }, "Target Index", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.details.journal.target_index) = $event)),
                    placeholder: "Sinta 2, Scopus Q3, etc.",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.details.journal.target_index]
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _cache[66] || (_cache[66] = _createElementVNode("label", { class: "form-label" }, "Field of Study", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.details.journal.field_of_study) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.details.journal.field_of_study]
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _cache[68] || (_cache[68] = _createElementVNode("label", { class: "form-label" }, "Language", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.details.journal.language) = $event))
                  }, _cache[67] || (_cache[67] = [
                    _createElementVNode("option", { value: "id" }, "Indonesian", -1),
                    _createElementVNode("option", { value: "en" }, "English", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.details.journal.language]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.form.service_type === 'ALL')
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _cache[82] || (_cache[82] = _createElementVNode("h5", { class: "mb-3" }, "All Service Details", -1)),
                _createElementVNode("div", _hoisted_39, [
                  _cache[70] || (_cache[70] = _createElementVNode("label", { class: "form-label" }, "Source File Path/URL", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.details.all.source_file) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.details.all.source_file]
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _cache[72] || (_cache[72] = _createElementVNode("label", { class: "form-label" }, "Language", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.details.all.language) = $event))
                  }, _cache[71] || (_cache[71] = [
                    _createElementVNode("option", { value: "id" }, "Indonesian", -1),
                    _createElementVNode("option", { value: "en" }, "English", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.details.all.language]
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "allExQ",
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.details.all.exclude_quotes) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.details.all.exclude_quotes]
                    ]),
                    _cache[73] || (_cache[73] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "allExQ"
                    }, "Exclude Quotes (Plagiarism)", -1))
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "allExB",
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.details.all.exclude_bibliography) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.details.all.exclude_bibliography]
                    ]),
                    _cache[74] || (_cache[74] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "allExB"
                    }, "Exclude Bibliography (Plagiarism)", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _cache[76] || (_cache[76] = _createElementVNode("label", { class: "form-label" }, "Paraphrase Level", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.details.all.paraphrase_level) = $event))
                  }, _cache[75] || (_cache[75] = [
                    _createElementVNode("option", { value: "Light" }, "Light", -1),
                    _createElementVNode("option", { value: "Medium" }, "Medium", -1),
                    _createElementVNode("option", { value: "Heavy" }, "Heavy", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.details.all.paraphrase_level]
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _cache[77] || (_cache[77] = _createElementVNode("label", { class: "form-label" }, "Special Instructions (Paraphrase)", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.details.all.special_instructions) = $event)),
                    rows: "2"
                  }, null, 512), [
                    [_vModelText, _ctx.details.all.special_instructions]
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _cache[78] || (_cache[78] = _createElementVNode("label", { class: "form-label" }, "Guideline File Path/URL (Doc Fix)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.details.all.guideline_file) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.details.all.guideline_file]
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _cache[79] || (_cache[79] = _createElementVNode("label", { class: "form-label" }, "Fix Notes (Doc Fix)", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.details.all.fix_notes) = $event)),
                    rows: "2"
                  }, null, 512), [
                    [_vModelText, _ctx.details.all.fix_notes]
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _cache[80] || (_cache[80] = _createElementVNode("label", { class: "form-label" }, "Target Index (Journal)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.details.all.target_index) = $event)),
                    placeholder: "Sinta 2, Scopus Q3, etc.",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.details.all.target_index]
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _cache[81] || (_cache[81] = _createElementVNode("label", { class: "form-label" }, "Field of Study (Journal)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.details.all.field_of_study) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.details.all.field_of_study]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_50, [
            _createVNode(_component_RouterLink, {
              to: "/orders",
              class: "btn btn-secondary fs-15 fw-medium"
            }, {
              default: _withCtx(() => _cache[83] || (_cache[83] = [
                _createTextVNode("Cancel")
              ])),
              _: 1
            }),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary fs-15 fw-medium",
              disabled: _ctx.loading
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_52))
                : _createCommentVNode("", true),
              _cache[84] || (_cache[84] = _createTextVNode(" Create Order "))
            ], 8, _hoisted_51)
          ])
        ], 32)
      ])
    ])
  ]))
}